export const getSubmitText = (source: string) => {
  if (source === 'refill') {
    return 'Пополнить';
  }

  return 'Оплатить';
};
